export function getSearchParamFromURL(url: string | null, param: string) {
    if(url) {
        return new URL(url).searchParams.get(param);
    } else {
        return null;
    }
}